import gql from "graphql-tag";

export default gql`

mutation jobStop($jobId: String!) {
  jobStop(id: $jobId)
}

`